<template>
	<button class="btn" @click="onClick">
		<slot></slot>
	</button>
</template>
<script>
export default {
	name: 'ButtonAction',
	props: {
		onClick: {
			type: Function,
			default: function () {
				return 0
			}
		}
	}
}
</script>
<style lang="scss" scoped>
	button {
		border: none;
		outline: none;
		background-color: $success-color;
		color: #fff;
		font-family: $font-family;
		font-weight: $font-weight-buttons;
		font-size: $font-size-button;
		border-radius: 5px;
		padding: 20px 0;
		cursor: pointer;

		&:disabled {
			background-color: rgba($success-color, 0.7);
			cursor: default;
		}

		// Button Size
		&.large {
			width: 260px;
		}

		&.small {
			width: 200px;
		}

		&.xs {
			width: 90px;
			padding: 12px 0;
		}

		// Button Styles
		&.danger {
			background: $danger-color;
			color: #fff;
		}

		&.blue {
			background: $success-color;
			&:hover {
				background-color: #2951A7;
			}
		}

		&.default {
			background: $default-color;
			color: $main-color;
		}
	}
</style>
